export default __webpack_public_path__ + "_/images/svg_icons/prize-star-a010cfb3234096f9d5a06ea1a3ca6ffdd7a28a399bdaf1d582eb4917ea636831.svg";